import { MdsIcon } from "@/design-system/components/icon/MdsIcon";
import styled from "@emotion/styled";

export const SmallerIcon = styled(MdsIcon)({
  height: 12,
  width: 12,
});
